<template>
	<div class="upload__container flex">
		<div class="upload__container__item flex">
			<label>Podpis</label>
			<textarea type="text" v-model="title"></textarea>
			<label>Tagi:</label>
			<textarea v-model="tags"></textarea>
			<div class="checkbox flex">
				<input type="checkbox" v-model="filePublic" />
				<label for="">Post publiczny</label>
			</div>
			<div class="checkbox flex" v-if="hasVideoFiles">
				<input type="checkbox" v-model="useOriginalDate" />
				<label for="">Użyj oryginalnej daty nagrania</label>
			</div>
			<div
				class="file__preview"
				v-for="(file, index) in filesPreview"
				:key="`fileSrc-${index}`"
			>
				<div class="file__preview__close" @click="clearPreview(index)">
					<DeleteImg></DeleteImg>
				</div>
				<video
					v-if="file.type === 'video'"
					:src="file.src"
					controls
					playsinline
					preload="auto"
					class="preview-video"
				></video>
				<img v-else :src="file.src" />
			</div>
			<div class="file__input">
				<button class="btn btn-reverse">Dodaj plik</button>
				<input
					type="file"
					name="images"
					multiple="multiple"
					ref="imageInput"
					@change="addFile($event.target.files)"
				/>
			</div>
		</div>
		<div class="upload__info">
			{{ info }}
		</div>
		<button class="btn" @click="send">
			<span v-if="!saving">Dodaj</span>
			<span class="spinner__container flex" v-if="saving">
				<Spinner :size="20" :color="color"></Spinner>
			</span>
		</button>
		<button class="btn btn-cancel" @click="clear">Anuluj</button>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import DeleteImg from "@/assets/img/times-solid.svg";

export default {
	components: {
		DeleteImg,
	},
	data() {
		return {
			fileName: "",
			payload: "",
			title: "",
			tags: "",
			filePublic: true,
			useOriginalDate: false,
			color: "#000",
			filesToUpload: [],
			filesPreview: [],
		};
	},
	computed: {
		...mapState(["info", "saving"]),
		hasVideoFiles() {
			return this.filesPreview.some((file) => file.type === "video");
		},
	},
	methods: {
		...mapActions(["message", "savePost"]),
		...mapActions({ processing: "saving" }),
		send() {
			const formData = new FormData();

			this.filesToUpload.forEach((file) => {
				formData.append("images", file);
			});
			formData.append("title", this.title);
			formData.append("tags", this.tags);
			formData.append("public", this.filePublic);
			formData.append("useOriginalDate", this.useOriginalDate);

			const payload = formData;

			this.processing(true);
			this.savePost(payload);
			this.message("Dodawanie obrazka");
		},
		clear() {
			this.message("");
			this.file = {};
			this.title = "";
			this.tags = "";
			this.$refs.imageInput.value = null;
			this.filesPreview = [];
			this.filesToUpload = [];
			this.filePublic = true;
			this.useOriginalDate = false;
		},
		addFile(files) {
			this.clearPreview();
			this.message("");

			for (let i = 0; i < files.length; i++) {
				const fileType = this.checkFileType(files[i].type);

				if (fileType === "image" || fileType === "video") {
					this.filesToUpload.push(files[i]);
					const reader = new FileReader();

					reader.onload = () => {
						const fileUrl = reader.result;
						this.filesPreview.push({
							src: fileUrl,
							type: fileType,
						});
					};

					reader.readAsDataURL(files[i]);
				} else {
					this.message("Niedozwolony rodzaj pliku");
				}
			}
		},
		clearPreview(item) {
			if (item !== undefined) {
				this.filesPreview.splice(item, 1);
				this.filesToUpload.splice(item, 1);
			} else {
				this.filesPreview = [];
				this.filesToUpload = [];
			}
		},
		checkFileType(file) {
			const fileType = file.split("/")[0];

			return fileType;
		},
	},
};
</script>
